export default "__VITE_ASSET__zUzpdZPm__"